import TypographyParagraph from '../../typography/TypographyParagraph'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import { useRef } from 'react'
import Image from '#app/components/content/Image'

export default function CastTemplate({ cast }: { cast: any }) {
	const tooltipCopyCastUrl = useRef<TooltipRefProps>(null)
	const tooltipCopyComment = useRef<TooltipRefProps>(null)
	const tooltipCopyIpfsUrl = useRef<TooltipRefProps>(null)
	const tooltipCopyPng = useRef<TooltipRefProps>(null)
	const tooltipCopySignature = useRef<TooltipRefProps>(null)

	const extractIPFSCID = (ipfsURL: string) => {
		const ipfsSegments = ipfsURL.split('/')
		return ipfsSegments[ipfsSegments.length - 1]
	}

	return (
		<>
			<div
				id="castUrl"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					const castURL = cast.properties.ipfsCID.includes('https://')
						? cast.properties.ipfsCID
						: `https://af-web3dir.infura-ipfs.io/ipfs/${cast.properties.ipfsCID}`
					navigator.clipboard.writeText(castURL)
					tooltipCopyCastUrl.current?.open({
						anchorSelect: '#castUrl',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyCastUrl.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyCastUrl} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Social Post URL:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{cast.properties.url}
				</TypographyParagraph>
			</div>
			<div
				id="comment"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(cast.properties.description)
					tooltipCopyComment.current?.open({
						anchorSelect: '#comment',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyComment.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyComment} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Comment:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
				>
					{cast.properties.description}
				</TypographyParagraph>
			</div>
			<div
				id="ipfsUrl"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					const castURL = cast.properties.ipfsCID.includes('https://')
						? cast.properties.ipfsCID
						: `https://af-web3dir.infura-ipfs.io/ipfs/${cast.properties.ipfsCID}`
					navigator.clipboard.writeText(castURL)
					tooltipCopyIpfsUrl.current?.open({
						anchorSelect: '#ipfsUrl',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyIpfsUrl.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyIpfsUrl} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					IPFS CID:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{extractIPFSCID(cast.properties.ipfsCID)}
				</TypographyParagraph>
			</div>
			<div
				id="png"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					const castURL = cast.properties.ipfsCID.includes('https://')
						? cast.properties.ipfsCID
						: `https://af-web3dir.infura-ipfs.io/ipfs/${cast.properties.ipfsCID}`
					navigator.clipboard.writeText(castURL)
					tooltipCopyPng.current?.open({
						anchorSelect: '#png',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyPng.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyPng} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					PNG:
				</TypographyParagraph>
				<Image
					className="h-auto w-1/3"
					imageUrl={cast.properties.ipfsCID}
					imageAlt={cast.properties.ipfsCID}
					containerClassName="flex items-center justify-center w-full"
				/>
			</div>
			<div
				id="signature"
				className="flex flex-row p-4 hover:bg-uiSecondaryLight dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(cast.signature)
					tooltipCopySignature.current?.open({
						anchorSelect: '#signature',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopySignature.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopySignature} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Signature:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{cast.signature}
				</TypographyParagraph>
			</div>
		</>
	)
}
